module.exports = __webpack_public_path__ + "media/images/konsultamd-d114d964c5382dc878abf5587ce80bc5.png";